export default __webpack_public_path__ + "static/media/bus61.2acbdc7d.svg";